export const menuList = [{ name: 'Sconn Auth', id: 'ap-northeast-2_POAJmlJnR' }]
